import React from 'react';
import './OurServicesAbout.css';
import {
    FaCogs,
    FaFileContract,
    FaHandshake,
    FaClipboardList,
    FaTasks,
  } from "react-icons/fa";
export default function OurServicesAbout() {
    const serviceCategories = [
        {
          icon: <FaCogs className="category-icon" />,
          title: "Engineering",
          services: ["PESO", "Architectural Plan"],
        },
        {
          icon: <FaFileContract className="category-icon" />,
          title: "Licensing",
          services: [
            "PESO",
            "Forest Clearance (FC)",
            "Environmental Clearance (EC)",
            "Consent to Establish (CTE)",
            "Consent to Operate (CTO)",
            "Hazardous Waste Licensing",
            "Bio-Medical Waste Authorization",
            "Fire Licensing",
            "Clinical Establishment Licensing",
          ],
        },
        {
          icon: <FaHandshake className="category-icon" />,
          title: "NOC Services",
          services: [
            "Fire NOC",
            "Central Ground Water Authority (CGWA)",
            "Airport Authority of India Height Clearance",
            "Water Allocation Order",
            "Various Government Officials NOCs",
          ],
        },
        {
          icon: <FaClipboardList className="category-icon" />,
          title: "Compliance and Audit",
          services: [
            "PESO Compliance",
            "Forest Clearance Compliance",
            "Environmental Clearance Compliance",
            "Consent to Operate (CTO) Compliance",
            "Central Ground Water Authority (CGWA) Compliance",
          ],
        },
        {
          icon: <FaTasks className="category-icon" />,
          title: "Miscellaneous Services",
          services: [
            "Feasibility Study for Construction",
            "Environmental Impact Assessment (EIA)",
            "Tank Testing Certificate (Explosive)",
          ],
        },
      ];
  return (
   <>
    <section className="our-services-section">
      <div className="container">
        <h2 className="heading">Our Services</h2>
        <p className="subheading">
          Comprehensive regulatory consulting and liaison services tailored for diverse industrial and business needs.
        </p>
        <div className="categories-grid">
          {serviceCategories.map((category, index) => (
            <div key={index} className="category-card">
              {category.icon}
              <h3 className="category-title">{category.title}</h3>
              <ul className="service-list">
                {category.services.map((service, idx) => (
                  <li key={idx} className="service-item">
                    {service}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
   
   
   
   
   
   </>
  )
}
